import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import { allAnswersAPI } from '../services/api';
import NavBar from './NavBar';

const AllAnswers = () => {
  const [answers, setAnswers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    teacherName: '',
    answerChoice: '',
    search: '',
    page: 1,
    limit: 20
  });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 20,
    total: 0,
    pages: 0
  });
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetchAnswers();
    fetchStats();
  }, [filters]);

  const fetchAnswers = async () => {
    try {
      setLoading(true);
      const params = {
        ...(filters.teacherName && { teacherName: filters.teacherName }),
        ...(filters.answerChoice && { answerChoice: filters.answerChoice }),
        ...(filters.search && { search: filters.search }),
        page: filters.page,
        limit: filters.limit
      };

      const response = await allAnswersAPI.getAll(params);

      setAnswers(response.data.answers);
      setPagination(response.data.pagination);
    } catch (error) {
      console.error('Failed to fetch answers:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await allAnswersAPI.getStats();
      setStats(response.data);
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value,
      page: 1 // Reset to first page on filter change
    }));
  };

  const handlePageChange = (newPage) => {
    setFilters(prev => ({
      ...prev,
      page: newPage
    }));
  };

  const handleReset = () => {
    setFilters({
      teacherName: '',
      answerChoice: '',
      search: '',
      page: 1,
      limit: 20
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <NavBar />
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Tüm Cevaplar</h2>

            {/* Stats Section */}
            {stats && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div className="bg-white p-4 rounded-lg shadow">
                  <div className="text-sm text-gray-500">Toplam Cevap</div>
                  <div className="text-2xl font-bold text-gray-900">{stats.totalAnswers}</div>
                </div>
                <div className="bg-white p-4 rounded-lg shadow">
                  <div className="text-sm text-gray-500">Öğretmen Sayısı</div>
                  <div className="text-2xl font-bold text-gray-900">{stats.teacherStats.length}</div>
                </div>
                {/*<div className="bg-white p-4 rounded-lg shadow">*/}
                {/*  <div className="text-sm text-gray-500">En Aktif Öğretmen</div>*/}
                {/*  <div className="text-lg font-bold text-gray-900">*/}
                {/*    {stats.teacherStats[0]?._id || '-'}*/}
                {/*  </div>*/}
                {/*</div>*/}
              </div>
            )}

            {/* Filters */}
            <div className="bg-white p-4 rounded-lg shadow mb-6">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Öğretmen Adı
                  </label>
                  <input
                    type="text"
                    name="teacherName"
                    value={filters.teacherName}
                    onChange={handleFilterChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    placeholder="Öğretmen ara..."
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Cevap
                  </label>
                  <select
                    name="answerChoice"
                    value={filters.answerChoice}
                    onChange={handleFilterChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  >
                    <option value="">Tümü</option>
                    <option value="A">A</option>
                    <option value="B">B</option>
                    <option value="C">C</option>
                    <option value="D">D</option>
                    <option value="E">E</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Soru/Açıklama Ara
                  </label>
                  <input
                    type="text"
                    name="search"
                    value={filters.search}
                    onChange={handleFilterChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    placeholder="Ara..."
                  />
                </div>

                <div className="flex items-end">
                  <button
                    onClick={handleReset}
                    className="w-full px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700"
                  >
                    Filtreleri Temizle
                  </button>
                </div>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-4">Yükleniyor...</div>
          ) : answers.length === 0 ? (
            <div className="text-center py-8 bg-white rounded-lg shadow">
              <p className="text-gray-500">Hiç cevap bulunamadı</p>
            </div>
          ) : (
            <>
              <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                {answers.map((answer) => (
                  <div key={answer._id} className="bg-white rounded-lg shadow p-4">
                    <div className="mb-3">
                      <div className="flex justify-between items-start mb-2">
                        <span className="text-sm font-medium text-blue-600">
                          {answer.teacherName}
                        </span>
                        <span className="text-xs text-gray-500">
                          {new Date(answer.createdAt).toLocaleDateString('tr-TR')}
                        </span>
                      </div>
                      {answer.questionText && (
                        <p className="text-sm text-gray-600 mb-2">{answer.questionText}</p>
                      )}
                      <p className="font-bold text-lg">Cevap: {answer.answerChoice}</p>
                      <p className="text-sm text-gray-700 mt-1">
                        {answer.explanation.substring(0, 100)}...
                      </p>
                    </div>

                    <div className="flex justify-center mb-3">
                      <QRCodeCanvas
                        value={`${window.location.origin}/answer/${answer.shortId}`}
                        size={100}
                      />
                    </div>

                    <div className="flex justify-between items-center">
                      <span className="text-xs text-gray-500">
                        {answer.viewCount} görüntülenme
                      </span>
                      <Link
                        to={`/answer/${answer.shortId}`}
                        className="text-blue-600 hover:text-blue-800 text-sm"
                      >
                        Görüntüle
                      </Link>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {pagination.pages > 1 && (
                <div className="mt-6 flex justify-center space-x-2">
                  <button
                    onClick={() => handlePageChange(pagination.page - 1)}
                    disabled={pagination.page === 1}
                    className="px-3 py-1 border rounded-md disabled:opacity-50"
                  >
                    Önceki
                  </button>

                  <span className="px-3 py-1">
                    Sayfa {pagination.page} / {pagination.pages}
                  </span>

                  <button
                    onClick={() => handlePageChange(pagination.page + 1)}
                    disabled={pagination.page === pagination.pages}
                    className="px-3 py-1 border rounded-md disabled:opacity-50"
                  >
                    Sonraki
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllAnswers;
